import React from "react";
import order from "../../assets/order.svg";
import mijoz from "../../assets/mijoz.svg";
import kassa from "../../assets/kassa.svg";
import bugalteriya from "../../assets/bugalteriya.svg";
import setting from "../../assets/setting.svg";
import xodim from "../../assets/xodim.svg";
import navbat from "../../assets/navbat.svg";
import ombor from "../../assets/ombor.svg";

export const Order = () => {
  return <img src={order} alt="order" />;
};

export const Mijoz = () => {
  return <img src={mijoz} alt="mijoz" />;
};
export const Bugalteriya = () => {
  return <img src={bugalteriya} alt="bugalteriya" />;
};
export const Kassa = () => {
  return <img src={kassa} alt="kassa" />;
};
export const Navbat = () => {
  return <img src={navbat} alt="navbat" />;
};

export const Xodim = () => {
  return <img src={xodim} alt="xodim" />;
};
export const Ombor = () => {
  return <img src={ombor} alt="ombor" />;
};
export const Setting = () => {
  return <img src={setting} alt="setting" />;
};
